import "./styles/NewsDetail.css";
//BOOTSTRAP-------------------------
import { Container } from "react-bootstrap";
// REACT ROUTER DOM---------------
import { Link } from "react-router-dom";
// ICON LIBRARY ----------------------------
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

const NewsDetail = () => {
  return (
    <div className="news detail-news">
      <Container fluid>
        <Link to={"/news"}>
          <FontAwesomeIcon icon={faHouse} /> 首頁 / 最新消息 /{" "}
        </Link>

        <h1>【高中部暑秋班劃位公告】</h1>
        <h4>發布於 2022/05/31 12:33</h4>
        <p>
          成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。
        </p>
        <img className="main-img" src="/Assets/news.png" alt="" />
        <p>
          成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。
        </p>
        <p>
          成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。
        </p>
        <div className="flex">
          <img src="/Assets/news-dummy.png" alt="" />
          <p>
            成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。
          </p>
        </div>
      </Container>
    </div>
  );
};

export default NewsDetail;
